import React, { useContext } from "react"
import _cloneDeep from "lodash.clonedeep"
import { Spacer } from "./Spacer"
import { MachineContext } from "../fsm/useMachine"
import TextFlowObject from "../../model/TextFlowObject"
import { FontSelector } from "./FontNameSelector"
import { AlignLeft, AlignCenter, AlignRight } from "react-feather"
import { useEditorCoordinator } from "../text_editor/editorCoordinator"
import { applyRatio, unapplyRatio } from "../view_2/helpers"
import { editWrap } from "../text_editor/helpers"
import { StageBoundsType } from "../root/listeners";
import _debounce from "lodash.debounce"
import { DELEGATE } from "../fsm/types"
import Tooltip from "@material-ui/core/Tooltip"

export const TextControls: React.FC<{ size: StageBoundsType }> = ({ size }) => {
    const [current, send] = useContext(MachineContext)
    let { globalEditor } = useEditorCoordinator()
    const [globalEditorVal,] = globalEditor
    const currentObject = (current.context.currentObject! as TextFlowObject)
    const [timeVal, setTimeVal] = React.useState({timeout: null, interval: null})
    const [values, setValues] = React.useState(currentObject.attributedString_flbAttributesArray[0].size)
    const fontSizeTimeoutRef = React.useRef<NodeJS.Timeout | null>(null)
    const isUpdatingFontSize = React.useRef(false)

    React.useEffect(() => {
        if (isUpdatingFontSize.current) {
            return;
        }
        if (globalEditorVal && globalEditorVal.getMarkAttributes) {
            let fontSize = globalEditorVal?.getMarkAttributes("textStyle").fontSize
            if (fontSize) {
                fontSize = parseFloat(fontSize.replace("px", ""))
                const newValue = unapplyRatio({ fontSize }, size.ratio).fontSize;
                setValues(newValue)
                return
            }
        }
        const flb = currentObject.attributedString_flbAttributesArray[0]
        setValues(flb.size)
    }, [currentObject.attributedString_flbAttributesArray, currentObject.text, typeof globalEditorVal])

    /**
     * Sets the alignment of currObject to be requested value
     * @param val: alignment to be set
     */
    const setAlign = (val: "left" | "right" | "center") => {
        console.log("EDITOR", globalEditorVal)
        if (globalEditorVal) {
            console.log(val)
            editWrap(globalEditorVal, (editor) => {
                editor
                    .chain()
                    .focus()
                    .setTextAlign(val)
                    .run();
            })
        }
    }


    const increment = (direction: "up" | "down") => {
        isUpdatingFontSize.current = true;
        if (direction === "up") {
            setValues(prevValues => {
                const newValue = prevValues + 1;
                // Update the editor immediately
                if (globalEditorVal) {
                    const fontSize = applyRatio({ size: newValue }, size.ratio).size
                    if (!globalEditorVal.isEditable) {
                        globalEditorVal.commands.setTextSelection({from: 0, to: currentObject.text.length + 1})
                    }
                    globalEditorVal.chain()
                        .setFontSize(`${fontSize}px`).run();
                }
                // Debounce the model update - only send after user stops clicking
                if (fontSizeTimeoutRef.current) {
                    clearTimeout(fontSizeTimeoutRef.current);
                }
                fontSizeTimeoutRef.current = setTimeout(() => {
                    send({ type: DELEGATE, payload: { type: "SET_FONT_SIZE", size: newValue }, id: currentObject.id })
                    // Re-enable the effect after model is updated
                    setTimeout(() => {
                        isUpdatingFontSize.current = false;
                    }, 100);
                }, 300);
                return newValue;
            });
        } else {
            setValues(prevValues => {
                if (prevValues - 1 > 0) {
                    const newValue = prevValues - 1;
                    // Update the editor immediately
                    if (globalEditorVal) {
                        const fontSize = applyRatio({ size: newValue }, size.ratio).size
                        if (!globalEditorVal.isEditable) {
                            globalEditorVal.commands.setTextSelection({from: 0, to: currentObject.text.length + 1})
                        }
                        globalEditorVal.chain()
                            .setFontSize(`${fontSize}px`).run();
                    }
                    // Debounce the model update - only send after user stops clicking
                    if (fontSizeTimeoutRef.current) {
                        clearTimeout(fontSizeTimeoutRef.current);
                    }
                    fontSizeTimeoutRef.current = setTimeout(() => {
                        send({ type: DELEGATE, payload: { type: "SET_FONT_SIZE", size: newValue }, id: currentObject.id })
                        // Re-enable the effect after model is updated
                        setTimeout(() => {
                            isUpdatingFontSize.current = false;
                        }, 100);
                    }, 300);
                    return newValue;
                }
                return prevValues;
            });
        }
    }


    // const [value, setValue] = React.useState("");

    // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const { value } = e.currentTarget;
    //     setValue(value);
    //     handleFontChange(value);
    // };

    // const handleFontChange = React.useCallback(
    //     _debounce((value) => {
    //         if (globalEditorVal) {
    //             const fontSize = applyRatio({ size: parseInt(value) }, size.ratio
    //             ).size
    //             console.info("[FONT SIZE]", fontSize)
    //             globalEditorVal.chain()
    //             .focus().setFontSize(`${fontSize}px`).run();
    //         }
    //     }, 500),
    //     []
    // );


    return (
        <div id="textControls" className="textControls">
            <form
                onSubmit={e => {
                    e.preventDefault()
                    e.stopPropagation()
                }}
            >
                <Tooltip title="Text Alignment">
                <input
                    className="location-input"                    
                    type="hidden"
                    name="mmoObject-alignment"
                    id="mmoObject-alignment"
                />
                </Tooltip>
                <FontSelector size={size}/>
                <div>
                    <button
                    type="button"
                    title="Decrease Font Size"
                    className="sizeButton"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        increment("down");
                    }}
                    >-</button>
                    <span className="font-size-display">{Math.floor(values)}</span>
                    <button
                    type="button"
                    title="Increase Font Size"
                    className="sizeButton"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        increment("up");
                    }}
                    >+</button>
                </div>
                <Spacer width={10} height={39} />
                <Tooltip title="Left Alignment">
                <AlignLeft
                    className="feather"
                    onClick={() => setAlign("left")}
                    id="leftAlign"
                />
                </Tooltip>
                <Spacer width={3} height={39} />
                <Tooltip title="Center Alignment">
                <AlignCenter
                    className="feather"
                    onClick={() => setAlign("center")}
                    id="centerAlign"
                />
                </Tooltip>
                <Spacer width={3} height={39} />
                <Tooltip title="Right Alignment">
                <AlignRight
                    className="feather"
                    onClick={() => setAlign("right")}
                    id="centerAlign"
                />
                </Tooltip>
                <Spacer width={6} height={39} />
            </form>
        </div>
    )
}

{/* <input
    className="location-input"
    title="Font Size"
    onFocus={() => send({ type: "MARK_ACTIVE", id: "fontSize" })}
    onChange={handleChange}
    onBlur={() => send({ type: "MARK_INACTIVE" })}
    id="fontSize"
    name="fontSize"
    size={3}
    defaultValue={values}
/> */}

TextControls.displayName = "TextControls"
export default TextControls

export const useDebounce = (fnToDebounce: (e: any) => any, durationInMs = 200) => {
    if (isNaN(durationInMs)) {
        throw new TypeError("durationInMs for debounce should be a number");
    }

    if (fnToDebounce == null) {
        throw new TypeError("fnToDebounce cannot be null");
    }

    if (typeof fnToDebounce !== "function") {
        throw new TypeError("fnToDebounce should be a function");
    }

    return React.useCallback(_debounce(fnToDebounce, durationInMs), [fnToDebounce, durationInMs]);
};
